/**
 * One array renders both the visible FAQ and its FAQPage JSON-LD, so the two
 * can never disagree. `index.html` deliberately carries no FAQPage of its own;
 * the prerender asserts there is exactly one.
 */

export interface Faq {
  q: string;
  a: string;
}

export const FAQ: readonly Faq[] = [
  {
    q: 'Does my data leave my building?',
    a: 'Not with Local AI: everything runs on a machine in your office. With Hybrid AI, only the jobs you choose go to the cloud, under rules you set, and we can set that up in Alibaba Cloud’s Bangkok region.',
  },
  {
    q: 'Do I need my own AI team?',
    a: 'No. We size the system, install it, connect it to your work, train your staff and support you after launch.',
  },
  {
    q: 'Does it work in Thai?',
    a: 'Yes. Thai is among the languages the Qwen model family supports. Send us a few of your own Thai documents and we will show you the results.',
  },
  {
    q: 'What are Qwen and DGX Spark?',
    a: 'Qwen is Alibaba’s family of AI models. Many of them are open-weight, so you can download them and run them on your own hardware. NVIDIA DGX Spark is a small AI computer that sits on a desk and runs them privately.',
  },
  {
    q: 'How do I start?',
    a: 'Explore PreMize at premize.agicafet.com, or tell us about your project. We reply with next steps.',
  },
];

export function faqJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}
